import { BreakPoint } from '@makemydeal/dr-activities-common';
import styled from 'styled-components';
import { Typography } from '@interstate/components/Typography';

export const LoaderWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-around;
    position: relative;
    min-height: 36px;
    width: 100%;

    & #interstitial-overlay-root {
        background-color: transparent;
        min-width: 32px;
        min-height: 36px;
    }
    & #interstitial-content-root {
        min-width: 32px;
        box-shadow: none;
    }
`;

export const UpdateOfferErrorFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 20px 24px 24px;
`;

export const FSErrorMessageHeading = styled(Typography)`
    margin-bottom: 0.571rem;
`;

export const FSErrorMessageText = styled(Typography)`
    ul {
        margin-bottom: 0;
    }
`;

export const UpdateOfferWithFSHandleFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 8.571rem;
    margin-bottom: 2.286rem;
    @media (max-width: calc(${BreakPoint.PHONE} - 1px)) {
        margin-top: 1.429rem;
    }
    button {
        width: 6.143rem;
    }
`;
